<template>
    <div class="invoice" id="invocie-create" :class="{ bgBlack: isImageMode }">
        <SOSlotBase :bg-grey="false" :loading="isFetching">
            <template v-slot:title-bar v-if="!isImageMode">
                <SOTitleBar :type="'back'" :page-title="page.title" @back="back" />
            </template>
            <template v-slot:loading-page>
                <div>
                    <SOLoadingPage />
                </div>
            </template>
            <template v-slot:content v-if="!isFetching">
                <div class="p-x-20 p-t-8">
                    <div class="m-d-16" v-if="!isImageMode">
                        <div class="form-group mod">
                            <label for="jumlah-transaksi" class="form-label require">Transaksi</label>
                            <div id="jumlah-transaksi" class="d-flex-between-center">
                                <div>
                                    <p class="m-d-0 f-16 f-c-black f-regular">
                                        {{ getTotalTransaksi }} Transaksi dipilih
                                    </p>
                                    <p class="m-d-0 f-14 f-c-midgrey f-regular">
                                        Total Invoice : Rp. {{ grandTotal | decimal }}
                                    </p>
                                </div>
                                <div @click="back">
                                    <p class="m-d-0 f-c-blue f-bold f-16">Ubah</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="m-d-16" v-if="!isImageMode">
                        <SOInputRegular
                            id="input-nama"
                            title="Nama Penerima"
                            placeholder="Nella Kharisma"
                            :required="true"
                            :value="post.nama_penerima"
                            autocomplete="off"
                            @input="onInput($event, 'nama_penerima')"
                        />
                        <ErrorMessage class="error" label="Nama Penerima" :validation="$v.post.nama_penerima" />
                    </div>
                    <div class="m-d-16">
                        <SOInputTelp
                            v-if="!isImageMode"
                            id="input-wa"
                            title="No WA Penerima"
                            :countryCode="post.kode_negara"
                            placeholder="8123456789"
                            autocomplete="off"
                            :value="post.telp"
                            @input="onInput($event, 'telp')"
                            @country-code="onInput($event, 'kode_negara')"
                        />
                        <ErrorMessage class="error" label="Nomor Whatsapp" :validation="$v.post.telp" />
                    </div>
                    <div class="m-d-16" v-if="!isImageMode">
                        <SOInputSelect
                            :title="`Penanggung Jawab`"
                            :selected="post.id_penanggung_jawab"
                            :placeholder="'Pilih Karyawan...'"
                            :options="karyawanOptions"
                            :required="true"
                            @option-selected="onInput($event, 'id_penanggung_jawab')"
                        />
                        <ErrorMessage
                            class="error"
                            label="Penanggung Jawab"
                            :validation="$v.post.id_penanggung_jawab"
                        />
                    </div>
                    <div class="m-d-16" v-if="!isImageMode">
                        <SOInputDateTime
                            title="Jatuh Tempo Invoice"
                            id="jatuh-tempo-invoice"
                            :placeholder="$moment().format('YYYY-MM-DD, HH:mm')"
                            :min-date="getDateNow"
                            :value="$moment().add(28, 'd').format('YYYY-MM-DD') + 'T' + $moment().format('HH:mm')"
                            :required="true"
                            @get-date="onInput($event, 'jatuhTempo')"
                        />
                        <ErrorMessage class="error" label="Jatuh Tempo Invoice" :validation="$v.post.jatuhTempo" />
                    </div>
                    <div class="separator-line"  v-if="!isImageMode"></div>
                    <div>
                        <SOButtonExpand
                            text="Data opsional"
                            id="optional-data"
                            :full-height="680"
                            ref="dataOptional"
                            @hook:mounted="onMountedDataOptional"
                        >  
                            <template v-slot:content>
                                <div style="padding-bottom: 130px">
                                    <div class="m-d-16">
                                        <SOUploadNota
                                            ref="uploadDokumen"
                                            id="camera-1"
                                            label="Dokumentasi"
                                            :images="uploadDokument"
                                            :camera-open="camera.open"
                                            :full-size="camera.fullSize"
                                            :preview-img="selectedPreview"
                                            @setCamera="onToggleCamera"
                                            @setFullSize="onToggleFullSize"
                                            @setImages="setImages"
                                            @deleteImg="onDeleteImg"
                                            @preview="onSelected"
                                            @hook:mounted="reloadImage"
                                        />
                                    </div>
                                    <div class="m-d-16" v-if="!isImageMode">
                                        <SOInputRegular
                                            id="input-keterangan"
                                            title="Keterangan"
                                            placeholder="Tulis keterangan invoice...."
                                            :value="post.keterangan"
                                            autocomplete="off"
                                            @input="onInput($event, 'keterangan')"
                                        />
                                    </div>
                                    <div class="separator" v-if="!isImageMode"></div>
                                    <div class="toggle-on-off f-regular" id="update-reminder" v-if="!isImageMode">
                                        <div class="d-flex m-d-12">
                                            <SOToggleOnOff
                                                check-id="pengingat-pelunasan"
                                                check-title=""
                                                nama="penggingat-pelunasan"
                                                :is-checked="toggleOnOff.reminder"
                                                @selected="onToggleCheck('reminder')"
                                            />
                                            <div @click="onToggleCheck('reminder')">
                                                <p class="m-d-0 f-16 f-c-black">Pengingat Pelunasan</p>
                                                <p class="m-d-0 f-14 f-c-midgrey">Kirim pesan ke konsumen saat jatuh tempo</p>
                                            </div>
                                        </div>
                                        <SODetailExpand
                                            ref="itemPengingat"
                                            id="item-pengingat"
                                            :full-height="getHeight"
                                            :expanded="toggleOnOff.reminder"
                                            v-if="renderExpand"
                                        >
                                            <template v-slot:custom-header>
                                                <div></div>
                                            </template>
                                            <template v-slot:content>
                                                <div>
                                                    <CardReminder :data-list="reminders" />

                                                    <SOButtonPlusLink text="Tambah pengingat" id="tambah-pengingat" @action="plusBtn" />
                                                </div>
                                            </template>
                                        </SODetailExpand>
                                    </div>
                                    <div class="separator" v-if="!isImageMode"></div>
                                    <div class="toggle-on-off f-regular d-flex align-items-baseline" v-if="!isImageMode">
                                        <SOToggleOnOff
                                            check-id="logo"
                                            check-title=""
                                            nama="logo"
                                            :is-checked="toggleOnOff.logo"
                                            @selected="onToggleCheck('logo')"
                                        />
                                        <p class="m-d-0 f-16 f-c-black" @click="onToggleCheck('logo')">
                                            Tampilkan Logo Outlet
                                        </p>
                                    </div>
                                    <div class="toggle-on-off f-regular d-flex" v-if="!isImageMode">
                                        <SOToggleOnOff
                                            check-id="dokumentasi"
                                            check-title=""
                                            nama="dokumentasi"
                                            :is-checked="toggleOnOff.dokumentasi"
                                            @selected="onToggleCheck('dokumentasi')"
                                        />
                                        <div @click="onToggleCheck('dokumentasi')">
                                            <p class="m-d-0 f-16 f-c-black">Tampilkan Dokumentasi Transaksi</p>
                                            <p class="m-d-0 f-14 f-c-midgrey">Foto yang diinput saat membuat transaksi</p>
                                        </div>
                                    </div>
                                    <div class="separator-line m-d-16" v-if="!isImageMode"></div>
                                    <div v-if="!isImageMode" class="order-by m-d-16">
                                        <p class="m-d-8 f-14 f-c-midgrey">Kelompokkan transaksi berdasarkan :</p>
                                        <p class="m-d-8 f-16 f-c-black d-flex" @click="onInput('1', 'tipe_kelompok')">
                                            <SORadioBtn :is-checked="post.tipe_kelompok === '1'" />
                                            <span class="m-l-8">Tanggal</span>
                                        </p>
                                        <!-- <p class="m-d-8 f-16 f-c-black d-flex">
                                            <SORadioBtn :is-checked="orderBy === 'status'" />
                                            <span class="m-l-8">Status Transaksi</span>
                                        </p> -->
                                        <p class="m-d-0 f-16 f-c-black d-flex" @click="onInput('3', 'tipe_kelompok')">
                                            <SORadioBtn :is-checked="post.tipe_kelompok === '3'" />
                                            <span class="m-l-8">Konsumen</span>
                                        </p>
                                    </div>
                                </div>
                            </template>
                        </SOButtonExpand>
                    </div>
                    <div class="separator"></div>
                        <div class="m-d-16 mt-4">
                            <div class="px-4 py-2 m-d-12 border rounded">
                                <div class="m-d-12">
                                    <div class="">
                                        <div class="d-flex-between-center">
                                            <p class="f-14 m-d-0">{{ getTotalTransaksi }} Nota</p>
                                            <p class="f-14 m-d-0">{{ getMcoinTotal }} M-Coin</p>
                                        </div>
                                        <div>
                                            <p class="f-12 f-c-blue m-d-0" @click="showDetailBiaya()">Lihat Detail</p>
                                        </div>
                                    </div>
                                    <div class="mt-3" v-if="Object.keys(kode_promo).length != 0">
                                        <div class="d-flex-between-center">
                                            <p class="f-14 text-uppercase m-d-0">{{ kode_promo.kode }}</p>
                                            <p class="f-14 m-d-0">- {{ getMcoinEstimation }} M-coin</p>
                                        </div>
                                        <div>
                                            <p class="f-12 badge-tag m-d-0">POTONGAN {{ kode_promo.diskon }}%, Maksimal diskon {{ kode_promo.maxDiskon }} M-coin</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="separator-line"></div>
                                <div class="m-t-12">
                                    <div class="d-flex-between-center">
                                        <p class="f-14 m-d-0" style="width: 120px;">Saldo M-Coin yang akan Dikurangi</p>
                                        <p class="f-14 f-bold">{{ getFinalMcoinTotal }} M-Coin</p>
                                    </div>
                                </div>
                            </div>
                            <div
                                @click="!isUseKodePromo && showPromoModal()"
                                class="p-x-16 p-y-10 d-flex justify-content-between align-items-center rounded border"
                            >
                                <div>
                                    <div class="f-14">
                                        {{isUseKodePromo ? 'Kode Promo Dipakai' : 'Gunakan Kode Promo'}}
                                    </div>
                                    <div v-if="!isUseKodePromo" class="f-14 f-c-blue">
                                        Masukan Promo
                                    </div>
                                    <div v-else class="f-14 f-c-green text-uppercase">
                                        {{kode_promo.kode}}
                                    </div>
                                </div>
                                <div>
                                    <div class="p-2" v-if="isUseKodePromo" @click.stop="clearKodePromo()">
                                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.410093 0.410093C0.73553 0.0846564 1.26317 0.0846564 1.5886 0.410093L5.99935 4.82084L10.4101 0.410093C10.7355 0.0846564 11.2632 0.0846564 11.5886 0.410093C11.914 0.73553 11.914 1.26317 11.5886 1.5886L7.17786 5.99935L11.5886 10.4101C11.914 10.7355 11.914 11.2632 11.5886 11.5886C11.2632 11.914 10.7355 11.914 10.4101 11.5886L5.99935 7.17786L1.5886 11.5886C1.26317 11.914 0.73553 11.914 0.410093 11.5886C0.0846564 11.2632 0.0846564 10.7355 0.410093 10.4101L4.82084 5.99935L0.410093 1.5886C0.0846564 1.26317 0.0846564 0.73553 0.410093 0.410093Z" fill="#DA1E28"/>
                                        </svg>
                                    </div>
                                    <i v-else class="f-14 f-c-blue fas fa-chevron-right"></i>
                                </div>
                            </div>
                        </div>
                    <div class="separator-line m-d-16" v-if="!isImageMode"></div>
                    <div class="m-d-16 floating-btn" v-if="!isImageMode">
                        <div>
                            <SOButton
                                :primary="true"
                                :full="true"
                                :text="'Buat & Lunasi Sekarang'"
                                :disable="!getTotalTransaksi"
                                :loading="isFetching"
                                :id="`lunasi-sekarang`"
                                @action="onSave(true)"
                            />
                        </div>
                        <div>
                            <SOButton
                                :outline="true"
                                :full="true"
                                :text="'Lunasi Nanti'"
                                :disable="!getTotalTransaksi"
                                :loading="isFetching"
                                :id="`lunasi-nanti`"
                                @action="onSave(false)"
                            />
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:modal>
                <ModalPromo
                    @selected="val => kode_promo = val"
                    ref="modalPromo"
                />
            </template>
        </SOSlotBase>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage.vue";
import SOUploadNota from "@/so-components/global/ui/SOUploadNota.vue";
import SORadioBtn from "@/so-components/global/ui/SORadioBtn.vue";
import SOButtonPlusLink from "@/so-components/global/ui/SOButtonPlusLink";
import SOButton from "@/so-components/global/ui/SOButton";
import SODetailExpand from "@/so-components/global/ui/SODetailExpand";
import SOButtonExpand from "@/so-components/global/ui/SOButtonExpand";

import ErrorMessage from "@/component-items/ErrorMessage";

import SOInputDateTime from "@/so-components/global/input/SOInputDateTime.vue";
import SOInputRegular from "@/so-components/global/input/SOInputRegular.vue";
import SOToggleOnOff from "@/so-components/global/input/SOToggleOnOff.vue";
import SOInputTelp from "@/so-components/global/input/SOInputTelp.vue";
import SOInputSelect from "@/so-components/global/input/SOInputSelectV1";
import ModalPromo from "../components/modals/ModalPromo.vue"

import { minLength, required, maxLength } from "vuelidate/lib/validators";

import CardReminder from "../components/CardReminder.vue";
import { moduleName } from "../store/state";

export default {
    name: "InvoiceCreate",
    components: {
        SOSlotBase,
        SOTitleBar,
        SOLoadingPage,
        SOButtonPlusLink,
        SOButton,
        SOUploadNota,
        SOInputDateTime,
        SOInputRegular,
        SOInputTelp,
        ErrorMessage,
        SOToggleOnOff,
        SORadioBtn,
        SODetailExpand,
        SOInputSelect,
        CardReminder,
        SOButtonExpand,
        ModalPromo,
    },
    data() {
        return {
            karyawanOptions: [],
            renderExpand: true,
            page: {
                title: "Buat Invoice",
                loading: false,
                from: "invoice.add",
            },
            dataOptional: false,
            toggleOnOff: {
                reminder: false,
                logo: false,
                dokumentasi: false,
            },
            uploadDokument: [],
            selectedPreview: null,
            camera: {
                open: false,
                fullSize: false,
            },
            kode_promo: {},
            post: {
                id_penanggung_jawab: "",
                nama_penerima: "",
                telp: "",
                kode_negara: "",
                is_select_all: 0,
                jatuhTempo: "",
                pengingat_pelunasan: [],
                tampilan_logo: 0,
                tampilan_dokumen: 0,
                id_outlet: null,
                tagihan: 0,
                jumlah_transaksi: 0,
                keterangan: "",
                tipe_kelompok: "1",
                dokumentasi: [],
            },
            Mcoin: 0,
            options: [
                {
                    kode: 'diskonharinasional',
                    discount: '25',
                    due_date: '2020-12-31',
                    available: 1,
                },
                {
                    kode: 'diskonharilibur',
                    discount: '25',
                    due_date: '2020-12-31',
                    available: 0,
                },
                {
                    kode: 'ownerpalingkeren',
                    discount: '25',
                    due_date: '2020-12-31',
                    available: 1,
                },
            ],
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === 'invoice.detail.pembayaran' ) {
                vm.$router.go(-2);
                return
            }
            if (from.name === 'invoice.detail.donesuccess' ) {
                vm.$router.go(-2);
                return
            }
            vm.setPageFrom(from.name);
            vm.setFocusScroll(from.name);
        });
    },
    watch: {
        reminders: function (rmNew, rmOld) {
            if (rmNew !== rmOld && rmNew.length > 0) {
                this.toggleOnOff.reminder = true;
                this.rerenderExpand();
            }
        },
    },
    validations: {
        post: {
            telp: {
                minLength: minLength(8),
            },
            nama_penerima: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(100),
            },
            jatuhTempo: {
                required,
            },
            id_outlet: {
                required,
            },
            id_penanggung_jawab: {
                required,
            },
        },
    },
    mounted() {
        this.autoFill();
        this.init();
    },
    computed: {
        getMcoinEstimation() {
            let max = this.kode_promo.maxDiskon
            let total = this.kode_promo.diskon / 100 * this.Mcoin
            let totalDisc = total <= max ? total : max
            return totalDisc
        },
        isUseKodePromo() {
            return !(this.kode_promo && Object.keys(this.kode_promo).length === 0 && Object.getPrototypeOf(this.kode_promo) === Object.prototype)
        },
        ...mapGetters(moduleName, {
            unSelectedTransaksi: "unSelectedTransaksi",
            selectedTransaksi: "selectedTransaksi",
            isCheckAll: "isCheckAll",
            transaksiList: "transaksiList",
            transaksiTotal: "transaksiTotal",
            grandTotal: "grandTotal",
            reminders: "reminders",
        }),
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        ...mapGetters("metaModule", {
            karyawan: "getKaryawanAll",
        }),
        getTotalTransaksi() {
            if (this.isCheckAll) {
                return this.transaksiTotal - this.unSelectedTransaksi.length;
            } else {
                return this.selectedTransaksi.length;
            }
        },
        getMcoinTotal() {
            if(this.getTotalTransaksi <= 20){
                return this.Mcoin = 1000;
            } else if(this.getTotalTransaksi >= 20){
                let total = this.getTotalTransaksi - 20;
                return this.Mcoin = total * 50 + 1000;
            }
            console.log(this.Mcoin)
        },
        getFinalMcoinTotal() {
            if(Object.keys(this.kode_promo).length != 0){
                let diskon = this.getMcoinEstimation
                let total = this.getMcoinTotal - diskon
                return total
            }else{
                return this.getMcoinTotal
            }
        },
        getIdOutlet() {
            return this.filterItem.oneOutlet;
        },
        isFetching() {
            return this.page.loading;
        },
        isImageMode() {
            return this.camera.open || this.camera.fullSize;
        },
        getHeight() {
            let item = 65 * this.reminders.length;
            return item + 30;
        },
        getDateNow() {
            return `${this.$moment().add(1, "days").format("YYYY-MM-DD")}T${this.$moment().format("HH:mm")}`;
        },
        grandTotal2() {
            let total = 0
            this.selectedTransaksi.forEach(selected => {
                total = total + this.transaksiList.find(transaksi => transaksi.idtransaksi == selected).grandtotal
            })
            return total
        }
    },
    methods: {
        ...mapActions({
            createInvoice: `${moduleName}/createInvoice`,
            setResponse: `${moduleName}/setResponse`,
            getFilterItem: `${moduleName}/getFilterItem`,
            fetchKaryawan: `metaModule/fetchKaryawanAll`,
        }),
        async init() {
            await this.setKaryawanAll();
        },
        autoFill() {
            let selected = []
            if (this.selectedTransaksi.length) {
                this.selectedTransaksi.forEach(id => {
                    selected.push(this.transaksiList.find(transaksi => transaksi.idtransaksi == id))
                })
                //cek apakah ada nama lain
                let counter = 0
                selected.forEach(element => {
                    if (element.nama != selected[0].nama) {
                        counter++
                    }
                });
                if (counter == 0) {
                    this.post.nama_penerima = selected[0].nama
                    if (selected[0].hasOwnProperty('phone')) {
                        this.post.telp = selected[0].telp
                        this.post.telp = selected[0].phone
                    }
                }
            }
        },
        clearKodePromo() {
            this.kode_promo = {}  
        },
        onMountedDataOptional() {
            this.$refs.dataOptional.setExpand(this.dataOptional);
        },
        back() {
            let idx = this.page.from === "invoice.add.confirm" ? -2 : -1;
            this.$router.go(idx);
        },
        async setKaryawanAll() {
            await this.setLoading(true);
            await this.fetchKaryawan();
            this.setLoading(false);
            this.karyawanOptions = [];
            this.karyawan.forEach((v) => {
                this.karyawanOptions = [
                    ...this.karyawanOptions,
                    {
                        id: v.idkaryawan,
                        text: v.nama,
                    },
                ];
            });
        },
        rerenderExpand() {
            this.renderExpand = false;

            this.$nextTick().then(() => {
                this.renderExpand = true;
            });
        },
        setPageFrom(val) {
            this.page.from = val;
        },
        onToggleCamera(val) {
            this.camera.open = val;
        },
        onToggleFullSize(val) {
            this.camera.fullSize = val;
        },
        setImages(data) {
            this.uploadDokument = data;
        },
        onDeleteImg(idx) {
            this.uploadDokument.splice(idx, 1);
        },
        onSelected(idx) {
            this.selectedPreview = idx;
        },
        reloadImage() {
            this.$refs.uploadDokumen.handleImages();
        },
        plusBtn() {
            this.$router.push({ name: "invoice.create.tambah_pengingat" });
        },
        onInput(val, key) {
            this.post[key] = val;
        },
        setFocusScroll(target) {
            if (target === "invoice.create.tambah_pengingat" || target === "invoice.create.update_pengingat") {
                document.getElementById("update-reminder").scrollIntoView();
                document.documentElement.scrollTop = document.documentElement.scrollTop - 53;
            }

            if (target === "invoice.create.detail_biaya") {
                document.getElementById("info-biaya").scrollIntoView();
            }
        },
        onToggleCheck(target) {
            this.toggleOnOff[target] = !this.toggleOnOff[target];
        },
        showDetailBiaya() {
            this.$router.push({ name: "invoice.create.detail_biaya" });
        },
        isValid() {
            let { telp, nama_penerima, jatuhTempo, id_outlet, id_penanggung_jawab } = this.$v.post;
            telp.$touch();
            nama_penerima.$touch();
            jatuhTempo.$touch();
            id_outlet.$touch();
            id_penanggung_jawab.$touch();

            return (
                telp.$invalid ||
                nama_penerima.$invalid ||
                jatuhTempo.$invalid ||
                id_outlet.$invalid ||
                id_penanggung_jawab.$invalid
            );
        },
        setLoading(val) {
            this.page.loading = val;
        },
        updatePost() {
            this.post.dokumentasi = this.uploadDokument;
            this.post.tampilan_dokumen = this.toggleOnOff.dokumentasi ? 1 : 0;
            this.post.tampilan_logo = this.toggleOnOff.logo ? 1 : 0;
            this.post.pengingat_pelunasan = this.reminders;
            this.post.is_select_all = this.isCheckAll ? 1 : 0;
            this.post.id_outlet = this.getIdOutlet;
            this.post.tagihan = this.grandTotal;
            this.post.uncheck_transaksi = this.unSelectedTransaksi;
            this.post.selected_transaksi = this.selectedTransaksi;
            this.post.jumlah_transaksi = this.getTotalTransaksi;
            this.post.jatuh_tempo = this.$moment(this.post.jatuhTempo).utc().format("YYYY-MM-DD HH:mm:ss");
            this.post.kode_coupon = this.isUseKodePromo ? this.kode_promo.kode : "";
        },
        async onSave(isRedirect) {
            await this.updatePost();
            if (this.isValid()) {
                if (this.$v.post.id_outlet.$invalid) {
                    this.$toast.error("Mohon pilih outlet Terlebih Dahulu");
                }
                this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
                return;
            }
            let posted = {
                ...this.post,
            };
            await this.getFilterItem().then((query) => {
                Object.keys(query).forEach((key) => {
                    if (query[key]) {
                        posted[key] = query[key];
                    }
                });
            });

            await this.setLoading(true);
            this.createInvoice(posted)
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                        this.setResponse(resulter.errorResult(res));
                    } else {
                        let { code, data, status, msg } = res.data;
                        if (code === 200 && status) {
                            if (!isRedirect) {
                                this.$router.push({ 
                                    name: "invoice.detail.donesuccess",
                                    params: { jenis: "lunasskrg", invoiceId: data.idinvoice },
                                    query: { totalInvoices: data.total_tagihan },
                                });
                            } else {
                                this.$router.push({
                                    name: "invoice.detail.pembayaran",
                                    params: { invoiceId: data.idinvoice },
                                    query: { totalInvoices: data.total_tagihan },
                                });
                            }
                            this.$toast.success(msg);
                            this.setResponse(resulter.successResult(msg));
                        } else {
                            this.$toast.error(msg);
                            this.setResponse(resulter.errorResult(msg));
                        }
                    }
                    this.setLoading(false);
                })
                .catch((err) => {
                    this.setLoading(false);
                    this.$toast.error(err);
                    this.setResponse(resulter.errorResult(e));
                });
        },
        showPromoModal() {
            console.log('tes')
            this.$refs.modalPromo.open();
        }
    },
};
</script>
<style scoped src="../static/style.css">
    .box {
        border: 1px solid #c8d0dd;
        box-sizing: border-box;
        border-radius: 4px;
    }
</style>
